import React, {Component} from 'react';
import Footer from '../components/partials/Footer';
import MockMenu from '../components/partials/MockMenu';
import ProgressBar from '../components/partials/ProgressBar';


class AccountLayout extends Component {
  render() {

    return (
      <div>
        <MockMenu />
        <ProgressBar />
        {this.props.children}
        <Footer />
      </div>
    );
  }
}

export default AccountLayout;



// WEBPACK FOOTER //
// ./src/containers/AccountLayout.js